import AreaPage from "@/components/AreaPage";

const area = {
  name: "Sushant Lok",
  slug: "water-tank-cleaning-sushant-lok-gurugram",
  h1: "Water Tank Cleaning in Sushant Lok, Gurugram",
  description: "Water tank cleaning in Sushant Lok Phase 1, 2, 3, Gurugram. Independent houses and villas served with same-day service.",
  content1: "Sushant Lok (Phase 1, 2, and 3) is one of Gurugram's premier residential areas known for spacious independent houses, villas, and plotted developments. TankBuddy provides comprehensive water tank cleaning for Sushant Lok residents — from compact 500-litre rooftop tanks to large 10,000-litre underground reservoirs common in bungalows and villas here.",
  content2: "Sushant Lok's mature tree-lined streets and older construction mean many tanks here are concrete/RCC types that develop significant algae and biofilm over years. Our specialized cleaning process includes manual scrubbing of stubborn deposits followed by high-pressure jet washing and UV disinfection — restoring even decades-old tanks to near-new condition. Book your cleaning today and protect your family's health.",
  nearby: [
    { href: "/water-tank-cleaning-dlf-phase-gurugram", label: "DLF Phase 1-5" },
    { href: "/water-tank-cleaning-mg-road-gurugram", label: "MG Road" },
    { href: "/water-tank-cleaning-sector-56-57-gurugram", label: "Sector 56-57" },
    { href: "/water-tank-cleaning-palam-vihar-gurugram", label: "Palam Vihar" },
  ],
};

export default function SushantLokPage() {
  return <AreaPage area={area} />;
}
